module.exports = __webpack_public_path__ + "img/sol_cap2.730870a2.png";